/**
 * Extracts the ETFs from the portfolio
 * @param symbolMapping {Object} - The symbol mapping object
 * @param globalTickerList {Array} - The global ticker list
 * @returns {{symbol: *, weight: *}[]}
 */
export const extractEtfsFromPortfolio = (symbolMapping, globalTickerList) => {
    const uniqueIds = Object.keys(symbolMapping).filter(x=>symbolMapping[x] > 0);
    const etfIds = uniqueIds.filter(x=>globalTickerList.find(t=>t.symbol===x && t.type==='etf'));
    if (etfIds.length===0) return;

    const etfs = etfIds.map(id=>({
        symbol: id,
        weight: symbolMapping[id]
    }))

    return etfs;
}
